import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';

import { Grid } from '../../components';
import {
    eixoService,
    areaService,
    certificadoService,
    Utils,
} from '../../services';
import PrincipalMaster from '../master/Principal';
import PublicMaster from '../master/Public';

class ImprimirCertificado extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            tituloTrabalho: '',
            nomeAutor: '',
            nomeOrientador: '',
            eventosSubeventos: {
                eventos: [],
                subeventos: [],
            },
            areas: [],
            eixos: [],
            eventoSelecionado: 0,
            subeventoSelecionado: 0,
            areaSelecionada: 0,
            eixoSelecionado: 0,
            dsCertificados: [],
        };
        Utils.showLoading(true);
    }

    async componentWillMount() {
        const eventosSubeventos = await certificadoService.getEventosSubeventos();
        this.setState({ eventosSubeventos }, async () => {
            const { evento } = this.props.match.params;
            if (evento) {
                const eventoUncoded = atob(evento);
                if (eventosSubeventos.subeventos[eventoUncoded]) {
                    this.setState({ eventoSelecionado: +eventoUncoded });
                }
            }
            Utils.showLoading(false);
        });
    }

    async onBuscarAreasSubevento(subevento) {
        this.setState({
            subeventoSelecionado: subevento,
            areaSelecionada: 0,
            eixoSelecionado: 0,
        });
        const areas = await areaService.getAreas(subevento);
        this.setState({ areas });
    }

    async onBuscarEixosArea(area) {
        this.setState({ areaSelecionada: area, eixoSelecionado: 0 });
        const eixos = await eixoService.getEixos(area);
        this.setState({ eixos });
    }

    async onSubmit(event) {
        event.preventDefault();
        await this.buscarCertificados();
    }

    async buscarCertificados() {
        const {
            areaSelecionada,
            eixoSelecionado,
            eventoSelecionado,
            subeventoSelecionado,
            nomeAutor,
            tituloTrabalho,
            nomeOrientador,
        } = this.state;
        if (
            eventoSelecionado === 0 &&
            subeventoSelecionado === 0 &&
            areaSelecionada === 0 &&
            eixoSelecionado === 0 &&
            nomeAutor === '' &&
            nomeOrientador === '' &&
            tituloTrabalho === ''
        ) {
            Utils.showToast(
                'Faça pelo menos um filtro para buscar os certificados.',
            );
            return;
        }
        Utils.showLoading(true);
        try {
            const response = await certificadoService.buscarCertificados({
                areaSelecionada,
                eixoSelecionado,
                eventoSelecionado,
                subeventoSelecionado,
                nomeAutor,
                tituloTrabalho,
                nomeOrientador,
            });
            this.setState({ dsCertificados: response.certificados }, () =>
                Utils.showLoading(false),
            );
        } catch (error) {
            Utils.showToast(error.message);
            Utils.showLoading(false);
        }
    }

    render() {
        const {
            tituloTrabalho,
            eventoSelecionado,
            subeventoSelecionado,
            eventosSubeventos,
            areas,
            areaSelecionada,
            eixos,
            eixoSelecionado,
            nomeAutor,
            nomeOrientador,
            dsCertificados,
        } = this.state;
        const { match } = this.props;
        const MasterPage = Utils.getUsuarioEstaLogado()
            ? PrincipalMaster
            : PublicMaster;
        const urlEvento = `/certificados/${btoa(eventoSelecionado)}`;

        return (
            <MasterPage
                title="Imprimir Certificados de Aprovação e Apresentação e Anais"
                {...this.props}
            >
                <div>
                    <div className="padding-content">
                        {eventoSelecionado !== 0 && !match.params.evento && (
                            <div style={{ marginTop: 16 }}>
                                Link direto para o evento:&nbsp;
                                <a
                                    href={urlEvento}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {urlEvento}
                                </a>
                                <br />
                                <br />
                            </div>
                        )}
                        <form onSubmit={(e) => this.onSubmit(e)}>
                            <TextField
                                floatingLabelFixed
                                floatingLabelText="Digite parte do título do trabalho"
                                fullWidth
                                onChange={(e) =>
                                    this.setState({
                                        tituloTrabalho: e.target.value,
                                    })
                                }
                                value={tituloTrabalho}
                            />
                            <br />
                            <SelectField
                                floatingLabelText="Selecione um evento"
                                value={eventoSelecionado}
                                onChange={(_event, _index, value) =>
                                    this.setState({
                                        eventoSelecionado: value,
                                        subeventoSelecionado: 0,
                                        areaSelecionada: 0,
                                        eixoSelecionado: 0,
                                    })
                                }
                                fullWidth
                            >
                                <MenuItem
                                    key={0}
                                    value={0}
                                    primaryText="Nenhum evento selecionado"
                                />
                                {eventosSubeventos.eventos.map((evento) => (
                                    <MenuItem
                                        key={evento.CODIGO}
                                        value={evento.CODIGO}
                                        primaryText={evento.EVENTO}
                                    />
                                ))}
                            </SelectField>
                            <br />
                            <SelectField
                                floatingLabelText="Selecione um subevento"
                                value={subeventoSelecionado}
                                onChange={(_event, _index, value) =>
                                    this.onBuscarAreasSubevento(value)
                                }
                                fullWidth
                            >
                                <MenuItem
                                    key={0}
                                    value={0}
                                    primaryText="Nenhum subevento selecionado"
                                />
                                {(eventoSelecionado !== 0
                                    ? eventosSubeventos.subeventos[
                                          eventoSelecionado
                                      ]
                                    : []
                                ).map((subevento) => (
                                    <MenuItem
                                        key={subevento.CODIGO}
                                        value={subevento.CODIGO}
                                        primaryText={subevento.NOME}
                                    />
                                ))}
                            </SelectField>
                            <br />
                            <SelectField
                                floatingLabelText="Selecione uma área"
                                value={areaSelecionada}
                                onChange={(_event, _index, value) =>
                                    this.onBuscarEixosArea(value)
                                }
                                fullWidth
                            >
                                <MenuItem
                                    key={0}
                                    value={0}
                                    primaryText="Nenhuma área selecionada"
                                />
                                {areas.map((area) => (
                                    <MenuItem
                                        key={area.CODIGO}
                                        value={area.CODIGO}
                                        primaryText={area.NOME}
                                    />
                                ))}
                            </SelectField>
                            <br />
                            <SelectField
                                floatingLabelText="Selecione um eixo"
                                value={eixoSelecionado}
                                onChange={(_event, _index, value) =>
                                    this.setState({ eixoSelecionado: value })
                                }
                                fullWidth
                            >
                                <MenuItem
                                    key={0}
                                    value={0}
                                    primaryText="Nenhum eixo selecionado"
                                />
                                {eixos.map((eixo) => (
                                    <MenuItem
                                        key={eixo.CODIGO}
                                        value={eixo.CODIGO}
                                        primaryText={eixo.NOME}
                                    />
                                ))}
                            </SelectField>
                            <br />
                            <TextField
                                floatingLabelFixed
                                floatingLabelText="Digite parte do nome do autor"
                                fullWidth
                                onChange={(e) =>
                                    this.setState({ nomeAutor: e.target.value })
                                }
                                value={nomeAutor}
                            />
                            <br />
                            <TextField
                                floatingLabelFixed
                                floatingLabelText="Digite parte do nome do orientador"
                                fullWidth
                                onChange={(e) =>
                                    this.setState({
                                        nomeOrientador: e.target.value,
                                    })
                                }
                                value={nomeOrientador}
                            />
                            <br />
                            <br />
                            <RaisedButton
                                label="Buscar Projetos/Resumos"
                                primary
                                type="submit"
                            />
                            <br />
                            <br />
                            <Grid
                                rowsPerPage={20}
                                showSearch={false}
                                columnSortDefault={0}
                                stripedRows
                                textTableEmpty="Nenhum projeto/resumo encontrado para este filtro."
                                dataSource={dsCertificados}
                                columns={[
                                    {
                                        allowSort: false,
                                        width: '80%',
                                        name: (item) => (
                                            <div>
                                                <h3>{item.TITULO}</h3>
                                                <p style={{ fontSize: 12 }}>
                                                    {`${item.NOMESUBEVENTO} > `}
                                                    {`${item.NOMECATEGORIA} > `}
                                                    {`${item.NOMEAREA} > `}
                                                    {item.NOMEEIXO}
                                                </p>
                                                <p style={{ fontSize: 14 }}>
                                                    <span>
                                                        <RaisedButton
                                                            label="Certificado de Aprovação"
                                                            default
                                                            type="submit"
                                                            href={
                                                                item.URL_CERTIFICADO_APROVACAO
                                                            }
                                                        />
                                                    </span>
                                                    {item.ANAISLIBERADOS === 1 && (
                                                        <span
                                                            style={{
                                                                marginLeft: 10,
                                                            }}
                                                        >
                                                            <RaisedButton
                                                                label="Anais"
                                                                default
                                                                type="submit"
                                                                href={
                                                                    item.URL_RESUMO
                                                                }
                                                            />
                                                        </span>
                                                    )}
                                                </p>
                                            </div>
                                        ),
                                    },
                                    {
                                        width: '20%',
                                        allowSort: false,
                                        name: (item) => (
                                            <div>
                                                {item.AUTORES.map((autor) => (
                                                    <div
                                                        key={
                                                            autor.PESSOAS_CODIGO
                                                        }
                                                    >
                                                        {autor.URL_CERTIFICADO_APRESENTACAO ? (
                                                            <span>
                                                                <RaisedButton
                                                                    label={
                                                                        autor.NOME
                                                                    }
                                                                    default
                                                                    type="submit"
                                                                    href={
                                                                        autor.URL_CERTIFICADO_APRESENTACAO
                                                                    }
                                                                />
                                                            </span>
                                                        ) : (
                                                            <span>
                                                                {autor.NOME}{' '}
                                                            </span>
                                                        )}
                                                        <br />
                                                        <br />
                                                    </div>
                                                ))}
                                            </div>
                                        ),
                                    },
                                ]}
                            />
                        </form>
                    </div>
                </div>
            </MasterPage>
        );
    }
}

ImprimirCertificado.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            evento: PropTypes.string,
        }),
    }).isRequired,
};

export default ImprimirCertificado;
